export interface NavItem {
  label: string;
  path: string;
}

export interface MethodologyStep {
  index: string;
  title: string;
  desc: string;
}

export interface Testimonial {
  name: string;
  identity: string;
  quote: string;
}

export const siteName = "15黑料网";
export const siteTagline = "不追情绪，只理清楚";
export const siteDescription =
  "15黑料网是一个专注热点事件深度解读与内幕解析的内容平台。我们用时间线、关键角色与疑点清单，把一件事从「听说」还原到「看明白」。";

export const contactEmail = "editor@15heiliao.com";

export const navItems: NavItem[] = [
  { label: "首页", path: "/" },
  { label: "深度解读", path: "/analysis" },
  { label: "主题档案", path: "/topics" },
  { label: "常见问题", path: "/faq" },
  { label: "关于我们", path: "/about" },
];

export const methodologySteps: MethodologyStep[] = [
  {
    index: "01",
    title: "先还原时间线",
    desc: "把所有能查证到的时间点按顺序排好，谁先谁后、间隔多久，很多争议在排序之后就不需要争了。",
  },
  {
    index: "02",
    title: "再标出关键角色",
    desc: "一件事往往不是一个人的事。我们标注每个角色在节点上的实际动作，而不是他们的立场表态。",
  },
  {
    index: "03",
    title: "列出还没解释的疑点",
    desc: "比结论更重要的是问题清单。哪些说法对不上、哪些环节没有公开信息，我们逐条写出来。",
  },
  {
    index: "04",
    title: "最后做逻辑复盘",
    desc: "在事实与疑点之上，给出可被推翻的推理，而不是不可证伪的断言。",
  },
];

export const stats = [
  { value: "1,380+", label: "已完成的事件复盘" },
  { value: "42", label: "覆盖的细分主题" },
  { value: "94%", label: "读者读完率" },
  { value: "每周", label: "固定更新深度专栏" },
];

export const testimonials: Testimonial[] = [
  {
    name: "林述",
    identity: "长期读者 · 产品经理",
    quote:
      "别处看完只会更生气，这里看完起码知道事情的顺序是怎么走的。时间线那一栏是我每篇必看的部分。",
  },
  {
    name: "周与洲",
    identity: "内容从业者",
    quote:
      "疑点清单特别有用。它不急着下判断，而是把没解释清楚的地方一条条列出来，反倒更有说服力。",
  },
  {
    name: "程阅",
    identity: "媒体研究方向 · 在校研究生",
    quote:
      "写分析作业时会参考它的复盘结构：先有事实，再有质疑，最后才是推论，这个顺序很值得学。",
  },
  {
    name: "老谢",
    identity: "自由撰稿人",
    quote: "节奏克制，不煽动。看久了会发现，它真正在做的事情是把一件复杂的事讲得不复杂。",
  },
];

export const principles = [
  {
    title: "事实与推断分开写",
    desc: "属于公开信息的写在时间线里，属于我们判断的写进复盘段，两者的边界始终清晰。",
  },
  {
    title: "不做实名指控",
    desc: "对于未经权威渠道证实的内容，我们只在逻辑层面讨论机制与结构，不指向具体个人。",
  },
  {
    title: "允许被修正",
    desc: "我们保留更新说明。新的事实出现时，改的是复盘，而不是把旧观点藏起来。",
  },
];